import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST } from "../services/index";

// หัวข้อ blacklist (master) — company มาจาก header ใน services อัตโนมัติ
export const useBlacklistTopics = () => {
  return useQuery(["blacklistTopics"], async () => {
    const { result } = await GET(`/api/v1/blacklist/topic`);
    return result || [];
  });
};

// รายการ blacklist ของ user คนหนึ่ง (โชว์ + นับ) — scope ต่อ company ที่ backend
export const useBlacklistByUser = (userId) => {
  return useQuery(
    ["blacklistByUser", userId],
    async () => {
      const { result } = await GET(`/api/v1/blacklist/user/${userId}`);
      return result || [];
    },
    { enabled: !!userId }
  );
};

// สร้างรายการ blacklist (จาก CaseForm)
export const useCreateBlacklist = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/blacklist`, payload),
  });
};
